<template>
  <div style="position: relative; height: 600px">
    <div v-if="loading" class="loading-div">
      <Button loading shape="circle" type="primary"></Button>
      <div>loading...</div>
    </div>
    <Table :columns="tableTitle" :data="tableData" border stripe height="580">
      <template
        v-for="(item, len) in tableTitle"
        :slot="item.slot"
        slot-scope="{ row, index }"
      >
        <template v-if="item.button">
          <Button
            type="warning"
            @click="handSubmit(row)"
            size="small"
            :key="len"
          >
            {{ $t("update") }}
          </Button>
        </template>
        <InputNumber
          :key="len"
          v-model="tableData[index][item.slot]"
          v-else-if="item.inputNumber"
          :step="item.step"
          :min="0"
          style="width: 100%"
        >
        </InputNumber>
      </template>
    </Table>
  </div>
</template>
<script>
import { getGoodsInfo, saveGoodsInfo } from "@/api/double/list";

export default {
  props: {
    billId: {
      type: String,
    },
  },
  data() {
    return {
      tableData: [],
      loading: true,
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("shop_name"),
        key: "shop_name",
        align: "center",
        minWidth: 110,
      });
      columns.push({
        title: this.$t("cargo_number"),
        key: "cargo_number",
        align: "center",
        minWidth: 110,
      });
      columns.push({
        title: this.$t("case_number"),
        slot: "caseNumber",
        align: "center",
        minWidth: 100,
        step: 1,
        inputNumber: true,
      });
      columns.push({
        title: this.$t("outboundCtns"),
        key: "outNumber",
        align: "center",
        minWidth: 100,
      });
      columns.push({
        title: this.$t("operation"),
        slot: "btn",
        align: "center",
        button: true,
        width: 80,
      });
      return columns;
    },
  },
  mounted() {
    this.getList(this.billId);
  },
  methods: {
    handSubmit(row) {
      // this.loading = true;
      let data = {
        id: row.id,
        caseNumber: row.caseNumber,
      };
      saveGoodsInfo(data)
        .then((res) => {
          this.$Message[res.data.status ? "success" : "error"]({
            background: true,
            content: res.data.msg,
            duration: res.data.status ? 2 : 5,
          });
          if (res.data.status) {
            this.getList(this.billId);
            this.$parent.$parent.$page.getList();
            this.$parent.$parent.$page.closeLoading();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    hasPermission(id) {
      return this.$hasPermission(id);
    },
    getList(id) {
      this.tableData = [];
      this.loading = true;
      getGoodsInfo(id)
        .then((res) => {
          this.loading = false;
          if (!res.data.status) {
            this.$Message["error"]({
              background: true,
              content: res.data.msg,
              duration: 5,
            });
            return;
          }
          this.tableData = res.data.payload;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
